import { render } from "./BottomTabBar.vue?vue&type=template&id=7b2602f7&scoped=true"
import script from "./BottomTabBar.vue?vue&type=script&lang=js"
export * from "./BottomTabBar.vue?vue&type=script&lang=js"

import "./BottomTabBar.vue?vue&type=style&index=0&id=7b2602f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2602f7"]])

export default __exports__